import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { SearchEdit } from "~misc/icons";
import { initialPath } from "~misc/paths";
import mask from "~services/utils/mask";

const ClientHeader = ({ dados }) => {
  const navigate = useNavigate();
  const { formatNumerFix } = mask();
  const noDataMessage = "Sem dados cadastrados";
  const isProspect = !dados?.codigo && Boolean(dados?.codigoProspect);
  const isProspectConvertido = Boolean(dados?.codigo && dados?.codigoProspect);
  return (
    dados && (
      <div className={"bg-terciaria full-screen-width"} data-test-id="div-client-info-card">
        <div className="flex space-x-4 p-4 text-white container">
          <div className="w-full ">
            {dados && (
              <>
                <p className="font-bold text-xl">
                  {dados.codigo || dados.codigoProspect} - {dados.nomeFantasia || dados.razaoSocial}
                </p>
                <div className="md:grid md:grid-cols-2 mt-4 relative">
                  <p>
                    Endereço:{" "}
                    <strong>{`${dados.endereco.rua} ${dados.endereco.numero ?? ""} ${
                      dados.endereco.complemento ?? ""
                    } ${dados.endereco.bairro ?? ""}`}</strong>
                  </p>

                  <p>
                    Telefone: <strong>{formatNumerFix(dados.telefone) || noDataMessage}</strong>
                  </p>
                  <p>
                    Cidade: <strong>{dados.endereco.cidade.nome}</strong>
                    {dados?.cluster?.nome && <> Cluster ({dados.cluster.nome})</>}
                  </p>

                  {dados.clusterNome && (
                    <p>
                      Cluster: <strong>{dados.clusterNome || noDataMessage}</strong>
                    </p>
                  )}

                  <p>
                    Celular: <strong>{formatNumerFix(dados.celular) || noDataMessage}</strong>
                  </p>

                  <p>
                    Microrregião: <strong>{dados.microrregiao || noDataMessage}</strong>
                  </p>

                  {dados.suframa && (
                    <p>
                      Cliente com SUFRAMA: <strong>{dados.suframa ? "Sim" : "Não"}</strong>
                    </p>
                  )}

                  <p>
                    Segmento Desc: <strong>{dados.segmento || noDataMessage}</strong>
                  </p>

                  {dados.dupla_categoria && (
                    <p>
                      Cliente com Dupla Categoria: <strong>{dados.duplaCategoria ? "Sim" : "Não"}</strong>
                    </p>
                  )}

                  {dados.bloqueado && (
                    <p>
                      Cliente com bloqueio: <strong>{dados.bloqueado ? "Sim" : "Não"}</strong>
                    </p>
                  )}

                  <p>
                    Grupo Centralizador:
                    <strong>
                      {dados?.grupoCentralizador && dados?.grupoCentralizadorId != 1
                        ? dados?.grupoCentralizador
                        : noDataMessage}
                    </strong>
                  </p>
                  {dados?.trilha?.nome && (
                    <p>
                      Trilha:
                      <strong className="ml-2">{dados.trilha.nome}</strong>
                    </p>
                  )}

                  {dados?.nomeObra?.trim() && (
                    <p data-test-id="client-header-nome-obra">
                      Nome da Obra: <strong>{dados.nomeObra}</strong>
                    </p>
                  )}

                  {isProspectConvertido && (
                    <p data-test-id="client-header-codigo-prospect">
                      Código Prospect: <strong>{dados.codigoProspect}</strong>
                    </p>
                  )}

                  {dados.id && (
                    <div>
                      <Link
                        to={
                          isProspect
                            ? `${initialPath}/carteira/prospect/${dados.id}`
                            : `${initialPath}/carteira/recebedor/${dados.id}`
                        }
                        className="absolute right-0 top-[1rem]"
                      >
                        <SearchEdit />
                      </Link>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default ClientHeader;
